/** Совпадает с JWT_ACCESS_COOKIE_NAME на бэкенде */
export const TOKEN_KEY = 'grand78_access_token';
